import * as React from 'react';
import { ColumnCenter, ColumnRight, ColumnRoot } from './common';

export interface IColumnHeaderProps {
	contents: React.ReactNode;
	controls?: React.ReactNode;
	canDrag: boolean;
}

export const ColumnHeaderComp = (props: IColumnHeaderProps) => {
	const { canDrag, controls, contents } = props;

	return (
		<ColumnRoot>
			<ColumnCenter $canDrag={canDrag} className={canDrag ? 'dragHandle' : ''}>
				{contents}
			</ColumnCenter>
			{controls ? <ColumnRight>{controls}</ColumnRight> : null}
		</ColumnRoot>
	);
};
